import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { AppModule } from '@app/app.module';

import { env } from './environments/env';
import { platformBrowser } from '@angular/platform-browser';

console.log('[BOOT] main.ts loaded');
(window as any).__BOOT_MAIN__ = true;

if (env.get().production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
